export default "__VITE_ASSET__CkStuZoj__"